module.exports = __webpack_public_path__ + "static/media/streetplay.cf52eac1.jpg";